import script from "./AddFromList.vue?vue&type=script&setup=true&lang=js"
export * from "./AddFromList.vue?vue&type=script&setup=true&lang=js"

import "./AddFromList.vue?vue&type=style&index=0&id=1c07deb4&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c07deb4"]])

export default __exports__